"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["Unauthorised"] = "Unauthorised";
    ErrorCodes["NotReady"] = "NotReady";
    ErrorCodes["NotSigned"] = "NotSigned";
    ErrorCodes["NotOrigin"] = "NotOrigin";
    ErrorCodes["NotInitialized"] = "NotInitialized";
    ErrorCodes["NotConfigured"] = "NotConfigured";
    ErrorCodes["NotAvailable"] = "NotAvailable";
    ErrorCodes["NotSupported"] = "NotSupported";
    ErrorCodes["NotFound"] = "NotFound";
    ErrorCodes["ParameterMissing"] = "ParameterMissing";
    ErrorCodes["InvalidParameter"] = "InvalidParameter";
    ErrorCodes["InvalidFormat"] = "InvalidFormat";
    ErrorCodes["Mismatched"] = "Mismatched";
    ErrorCodes["DatabaseError"] = "DatabaseError";
    ErrorCodes["ConnectionError"] = "ConnectionError";
    ErrorCodes["InvalidRequest"] = "InvalidRequest";
    ErrorCodes["InvalidResponse"] = "InvalidResponse";
    ErrorCodes["UnexpectedResponse"] = "UnexpectedResponse";
    ErrorCodes["InvalidMessage"] = "InvalidMessage";
    ErrorCodes["UnexpectedMessage"] = "UnexpectedMessage";
    ErrorCodes["NumericFault"] = "NumericFault";
    ErrorCodes["MissingNew"] = "MissingNew";
    ErrorCodes["Failed"] = "Failed";
    ErrorCodes["Unknown"] = "Unknown";
    ErrorCodes["Censored"] = "Censored";
})(ErrorCodes = exports.ErrorCodes || (exports.ErrorCodes = {}));
;
exports.UNAUTHORISED = ErrorCodes.Unauthorised;
exports.NOT_READY = ErrorCodes.NotReady;
exports.NOT_SIGNED = ErrorCodes.NotSigned;
exports.NOT_ORIGIN = ErrorCodes.NotOrigin;
exports.NOT_INITIALIZED = ErrorCodes.NotInitialized;
exports.NOT_CONFIGURED = ErrorCodes.NotConfigured;
exports.NOT_AVAILABLE = ErrorCodes.NotAvailable;
exports.NOT_SUPPORTED = ErrorCodes.NotSupported;
exports.NOT_FOUND = ErrorCodes.NotFound;
exports.PARAMETER_MISSING = ErrorCodes.ParameterMissing;
exports.INVALID_PARAMETER = ErrorCodes.InvalidParameter;
exports.INVALID_FORMAT = ErrorCodes.InvalidFormat;
exports.MISMATCHED = ErrorCodes.Mismatched;
exports.DATABASE_ERROR = ErrorCodes.DatabaseError;
exports.CONNECTION_ERROR = ErrorCodes.ConnectionError;
exports.INVALID_REQUEST = ErrorCodes.InvalidRequest;
exports.INVALID_RESPONSE = ErrorCodes.InvalidResponse;
exports.UNEXPECTED_RESPONSE = ErrorCodes.UnexpectedResponse;
exports.INVALID_MESSAGE = ErrorCodes.InvalidMessage;
exports.UNEXPECTED_MESSAGE = ErrorCodes.UnexpectedMessage;
exports.NUMERIC_FAULT = ErrorCodes.NumericFault;
exports.MISSING_NEW = ErrorCodes.MissingNew;
exports.FAILED = ErrorCodes.Failed;
exports.UNKNOWN = ErrorCodes.Unknown;
exports.CENSORED = ErrorCodes.Censored;
exports.ServiceErrorCode = ErrorCodes; // will be depreciate
let _censorErrors = false;
function getCensor() {
    return _censorErrors;
}
exports.getCensor = getCensor;
function setCensor(value) {
    _censorErrors = value;
}
exports.setCensor = setCensor;
function throwError(code, message, params) {
    throw createError(code, message, params);
}
exports.throwError = throwError;
// @TODO: Enum
function createError(code, message, params) {
    if (_censorErrors) {
        code = ErrorCodes.Censored;
        message = ErrorCodes.Censored;
        params = undefined;
    }
    else {
        if (!code) {
            code = ErrorCodes.Unknown;
        }
        if (!params) {
            params = {};
        }
    }
    let messageDetails = [];
    Object.keys(params).forEach((key) => {
        try {
            messageDetails.push(key + '=' + JSON.stringify(params[key]));
        }
        catch (error) {
            messageDetails.push(key + '=' + JSON.stringify(params[key].toString()));
        }
    });
    let reason = message;
    if (messageDetails.length) {
        reason += ' (' + messageDetails.join(', ') + ')';
    }
    let error = new Error(message);
    error.reason = reason;
    error.code = code;
    Object.keys(params).forEach(function (key) {
        // Prevent collision
        let prefix = "";
        switch (key) {
            case "code":
            case "message":
            case "reason":
                prefix = "_";
        }
        error[prefix + key] = params[key];
    });
    return error;
}
exports.createError = createError;
function describeError(error) {
    return {
        code: (error && error.code) ? String(error.code) : "UnknownError",
        message: (error && error.message) ? String(error.message) : "<EMPTY MESSAGE>",
        reason: (error && error.reason) ? error.reason : ""
    };
}
exports.describeError = describeError;
//# sourceMappingURL=errors.js.map